import { selectByOS } from '@/utils/platform';

export class Keyboard {
  static get ctrl() {
    return selectByOS({
      macos: 'command',
      default: 'ctrl',
    });
  }

  static get command() {
    return this.ctrl;
  }
}

export const KEYBOARD_KEYS = {
  space: ['spacebar', ' '],
  enter: ['enter'],
};

export const KEYS_SPACEBAR_ENTER = [...KEYBOARD_KEYS['space'], ...KEYBOARD_KEYS['enter']];

export const onKey = (keys: string[], fn: () => void) => (event: KeyboardEvent) => {
  if (keys.includes(event.key.toLocaleLowerCase())) {
    event.preventDefault();
    event.stopPropagation();
    fn();
  }
};

export const onEnterSpace = (fn: () => void) => (event: KeyboardEvent) => {
  return onKey(KEYS_SPACEBAR_ENTER, fn)(event);
};

export const onEscape = (fn: () => void) => (event: KeyboardEvent) => {
  return onKey(['escape'], fn)(event);
};
